import type { AgentComponent } from '@reach/shared-types/agent-components';

interface ComponentOptionRowProps {
  component: Pick<AgentComponent, 'name' | 'description'>;
  selected: boolean;
  onToggle: () => void;
}

export const ComponentOptionRow = ({ component, selected, onToggle }: ComponentOptionRowProps) => (
  <li>
    <label>
      <input type="checkbox" checked={selected} onChange={onToggle} />
      <strong>{component.name}</strong>
      {component.description && <span>{component.description}</span>}
    </label>
  </li>
);
